<template>
  <div class="breadcrumb-container">
    <div class="tab-container">
      <div class="tab-items">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab-item"
          :class="{ active: isTabActive(tab.path) || (index === 0 && !isAnyTabActive()) }"
          @click="navigateTo(tab.path)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class="breadcrumb">
        <span class="breadcrumb-icon" ><img style="width: 2vw;bottom: 0;position: relative;top:0.2vw" src="@/assets/home/icon-home.png" alt="面包屑图标" /></span>
        <span>当前位置: </span>
        <span class="breadcrumb-link" @click="goToHome">首页</span>
        <span> > </span>
        <span class="breadcrumb-link" @click="goToProduct">产品中心</span>
        <span> > </span>
        <span class="breadcrumb-link current">{{ getCurrentTabName() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "productBreadCrumb",
  data() {
    return {
      tabs: [
        { name: '产朊假丝酵母蛋白', path: '/Product/ProductCandidaYeast/pig' },
        { name: '酿酒酵母培养物', path: '/Product/ProductGrainWineYeast/pig' },
        { name: '含可溶物的玉米干酒精糟', path: '/Product/ProductCornDryAlcohol/pig' },
        { name: '其他', path: '/Product/Other' },
      ]
    };
  },
  mounted() {
    // 如果当前路径不在已定义的标签中，默认导航到第一个标签
    if (!this.tabs.some(tab => {
      if (tab.path === '/Product/Other') {
        return this.$route.path === tab.path;
      }
      return this.$route.path.startsWith(tab.path.split('/').slice(0, -1).join('/'));
    })) {
      this.navigateTo(this.tabs[0].path);
    }
  },
  methods: {
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
    },
    isTabActive(path) {
      // 处理 Other 路径的特殊情况（不区分大小写）
      if (path.toLowerCase() === '/product/other') {
        return this.$route.path.toLowerCase().startsWith('/product/other');
      }
      // 对于其他标签，检查路径前缀（不区分大小写）
      return this.$route.path.toLowerCase().startsWith(path.toLowerCase().split('/').slice(0, -1).join('/'));
    },
    isAnyTabActive() {
      return this.tabs.some(tab => this.isTabActive(tab.path));
    },
    goToHome() {
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    goToProduct() {
      this.$router.push('/Product').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    getCurrentTabName() {
      // 首先检查当前路径是否匹配任何标签路径
      const currentTab = this.tabs.find(tab => this.isTabActive(tab.path));
      if (currentTab) {
        return currentTab.name;
      }

      // 如果没有找到匹配的标签，检查是否是 /Product/other 路径（不区分大小写）
      if (this.$route.path.toLowerCase() === '/product/other') {
        return '其他';
      }

      // 如果都没有匹配，返回第一个标签的名称
      return this.tabs[0].name;
    }
  }
};
</script>

<style scoped>
.breadcrumb-container {
  width: 100%;
  margin: 0 auto;
  padding: 0;
  position: relative;
  z-index: 2;
  font-family: 'SourceHanSansCN', sans-serif;
}

.tab-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*margin-bottom: 30px;*/
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 20px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: relative;
  z-index: 10;
  margin-top: -85px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.tab-items {
  display: flex;
  flex: 1;
}

.tab-item {
  padding: 10px 15px;
  margin-right: 10px;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  white-space: nowrap;
  box-sizing: border-box;
  min-width: 84px;
  text-align: center;
  color: #4d4d4d;
}

.tab-item.active {
  color: #0099ff;
  font-weight: normal;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #0099ff;
}

.breadcrumb {
  color: #999;
  font-size: 14px;
  flex: 2;
  text-align: right;
  white-space: nowrap;
}

.breadcrumb-link {
  cursor: pointer;
}

.breadcrumb-link:hover {
  color: #666;
}

.breadcrumb-link.current {
  color: #0099ff;
  font-weight: 500;
}

@media screen and (max-width: 768px) {
  .tab-container {
    width: 95%;
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-start;
  }
  .tab-container {
    display: none;
  }
  .breadcrumb {
    margin-top: 10px;
    text-align: left;
    width: 100%;
  }

  .tab-items {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 5px;
  }
}



</style>
